import { LogLevels } from '@powersync/common';
import { AbstractStreamingSyncImplementation, LockType } from '@powersync/shared-internals';
import { getNavigatorLocks } from '../../shared/navigator.js';
export class WebStreamingSyncImplementation extends AbstractStreamingSyncImplementation {
    diagnosticsChannel;
    constructor(options) {
        // Super will store and provide default values for options
        super(options);
    }
    /**
     * Broadcasts a core diagnostics event on a same-origin channel for diagnostics tooling to consume.
     * The channel reaches the page even when sync runs in a shared worker.
     */
    emitDiagnostics(event) {
        this.diagnosticsChannel ??= new BroadcastChannel('powersync-diagnostics-events');
        this.diagnosticsChannel.postMessage(event);
    }
    async dispose() {
        await super.dispose();
        this.diagnosticsChannel?.close();
        this.diagnosticsChannel = undefined;
    }
    get webOptions() {
        return this.options;
    }
    async obtainLock(lockOptions) {
        const identifier = `streaming-sync-${lockOptions.type}-${this.webOptions.identifier}`;
        if (lockOptions.type == LockType.SYNC) {
            this.logger.log({ level: LogLevels.debug, message: `requesting lock for ${identifier}` });
        }
        return getNavigatorLocks().request(identifier, { signal: lockOptions.signal }, lockOptions.callback);
    }
}
//# sourceMappingURL=WebStreamingSyncImplementation.js.map